<template>
  <div class="client-container">
    <bread-crumb />
    <div class="global-table-container">
      <a-tabs
        default-active-key="1"
        @change="handleChange"
      >
        <a-tab-pane
          key="1"
          tab="网站信息"
        >
          <web-message
            ref="webRef"
            :btn-is-loading="btnIsLoading"
            @handleSubmit="handleSubmit"
          />
        </a-tab-pane>
        <a-tab-pane
          key="2"
          tab="隐私条款"
          force-render
        >
          <div
            ref="privacyEditor"
          />
          <div class="btn-container">
            <a-button
              :loading="btnIsLoading"
              type="primary"
              style="margin-left:20px;"
              @click="handleSubmit"
            >
              保存
            </a-button>
          </div>
        </a-tab-pane>
		<a-tab-pane
		  key="8"
		  tab="反商业贿赂协议"
		  force-render
		>
		  <div
		    ref="anti_bribery"
		  />
		  <div class="btn-container">
		    <a-button
		      :loading="btnIsLoading"
		      type="primary"
		      style="margin-left:20px;"
		      @click="handleSubmit"
		    >
		      保存
		    </a-button>
		  </div>
		</a-tab-pane>
		<a-tab-pane
		  key="9"
		  tab="推广服务商推广行为准则"
		  force-render
		>
		  <div
		    ref="promote_industry_rule"
		  />
		  <div class="btn-container">
		    <a-button
		      :loading="btnIsLoading"
		      type="primary"
		      style="margin-left:20px;"
		      @click="handleSubmit"
		    >
		      保存
		    </a-button>
		  </div>
		</a-tab-pane>
        <a-tab-pane
          key="3"
          tab="医生端服务协议"
          force-render
        >
          <div
            ref="doctorEditor"
          />
          <div class="btn-container">
            <a-button
              :loading="btnIsLoading"
              type="primary"
              style="margin-left:20px;"
              @click="handleSubmit"
            >
              保存
            </a-button>
          </div>
        </a-tab-pane>
        <a-tab-pane
          key="4"
          tab="关于我们"
          force-render
        >
          <div
            ref="aboutEditor"
          />
          <div class="btn-container">
            <a-button
              :loading="btnIsLoading"
              type="primary"
              style="margin-left:20px;"
              @click="handleSubmit"
            >
              保存
            </a-button>
          </div>
        </a-tab-pane>
        <a-tab-pane
          key="5"
          tab="阿里云短信设置"
          force-render
        >
          <ali-component
            ref="aliRef"
            :btn-is-loading="btnIsLoading"
            @handleSubmit="handleSubmit"
          />
        </a-tab-pane>
        <a-tab-pane
          key="6"
          tab="评论设置"
          force-render
        >
          <comment-component
            ref="commentRef"
            :btn-is-loading="btnIsLoading"
            @handleSubmit="handleSubmit"
          />
        </a-tab-pane>
        <a-tab-pane
          key="7"
          tab="小程序设置"
          force-render
        >
          <mini-component
            ref="miniRef"
            :btn-is-loading="btnIsLoading"
            @handleSubmit="handleSubmit"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import webMessage from './components/web';
import aliComponent from './components/ali';
import commentComponent from './components/comment';
import miniComponent from './components/miniApp';
import E from 'wangeditor';
export default {
  components: {webMessage, aliComponent, commentComponent, miniComponent},
  data(){
    return {
      btnIsLoading: false,
      privacyContent: '',
      doctorContent: '',
      aboutContent: '',
	  antiContent:'',
	  promoteContent:''
    };
  },
  async mounted(){

    // 隐私协议
    let privacyEditor = new E(this.$refs.privacyEditor);
    privacyEditor.customConfig={
      onchange: (html) => {
        this.privacyContent = html;
      },
      customUploadImg: async(files, insert)=> {
        let formData=new FormData();
        formData.append('fileType', 'img');
        formData.append('upload', files[0]);
        let result =await this.$http.post(`${this.uploadUrl}fileup/up`, formData);
        if(result.data.status===1){
          insert(result.data.data.url);
        }
      },
    };
    privacyEditor.create();
	
	// 反商业贿赂协议
	let anti_bribery = new E(this.$refs.anti_bribery);
	anti_bribery.customConfig={
	  onchange: (html) => {
	    this.antiContent = html;
	  },
	  customUploadImg: async(files, insert)=> {
	    let formData=new FormData();
	    formData.append('fileType', 'img');
	    formData.append('upload', files[0]);
	    let result =await this.$http.post(`${this.uploadUrl}fileup/up`, formData);
	    if(result.data.status===1){
	      insert(result.data.data.url);
	    }
	  },
	};
	anti_bribery.create();
	
	// 推广服务商推广行为准则
	let promote_industry_rule = new E(this.$refs.promote_industry_rule);
	promote_industry_rule.customConfig={
	  onchange: (html) => {
	    this.promoteContent = html;
	  },
	  customUploadImg: async(files, insert)=> {
	    let formData=new FormData();
	    formData.append('fileType', 'img');
	    formData.append('upload', files[0]);
	    let result =await this.$http.post(`${this.uploadUrl}fileup/up`, formData);
	    if(result.data.status===1){
	      insert(result.data.data.url);
	    }
	  },
	};
	promote_industry_rule.create();
	
	
	
    // 医生端服务协议
    let doctorEditor = new E(this.$refs.doctorEditor);
    doctorEditor.customConfig={
      onchange: (html) => {
        this.doctorContent = html;
      },
      customUploadImg: async(files, insert)=> {
        let formData=new FormData();
        formData.append('fileType', 'img');
        formData.append('upload', files[0]);
        let result =await this.$http.post(`${this.uploadUrl}fileup/up`, formData);
        if(result.data.status===1){
          insert(result.data.data.url);
        }
      },
    };
    doctorEditor.create();
    // 关于我们
    let aboutEditor = new E(this.$refs.aboutEditor);
    aboutEditor.customConfig={
      onchange: (html) => {
        this.aboutContent = html;
      },
      customUploadImg: async(files, insert)=> {
        let formData=new FormData();
        formData.append('fileType', 'img');
        formData.append('upload', files[0]);
        let result =await this.$http.post(`${this.uploadUrl}fileup/up`, formData);
        if(result.data.status===1){
          insert(result.data.data.url);
        }
      },
    };
    aboutEditor.create();
    // 回显
    await this.getData();
    await privacyEditor.txt.html(this.privacyContent);
	 await anti_bribery.txt.html(this.antiContent);
	  await promote_industry_rule.txt.html(this.promoteContent);
	
    await doctorEditor.txt.html(this.doctorContent);
    await aboutEditor.txt.html(this.aboutContent);

  },
  methods: {
    // 获取网站信息
    async getData(){
      let result=await this.$http.post('/option/getOptionList');
      if(result.data.status===1){
        let temp=result.data.data.data_list;
        temp.site_info.wxapp_cover=[{
          uid: temp.site_info.wxapp_cover,
          url: temp.site_info.wxapp_cover_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.wxapp_cover_two=[{
          uid: temp.site_info.wxapp_cover_two,
          url: temp.site_info.wxapp_cover_two_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.wxapp_covers=[{
          uid: temp.site_info.wxapp_covers,
          url: temp.site_info.wxapp_covers_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.survey_img=[{
          uid: temp.site_info.survey_img,
          url: temp.site_info.survey_img_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.task_one_img=[{
          uid: temp.site_info.task_one_img,
          url: temp.site_info.task_one_img_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.task_two_img=[{
          uid: temp.site_info.task_two_img,
          url: temp.site_info.task_two_img_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.task_three_img=[{
          uid: temp.site_info.task_three_img,
          url: temp.site_info.task_three_img_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.wxapp_api_cover=[{
          uid: temp.site_info.wxapp_api_cover,
          url: temp.site_info.wxapp_api_cover_url,
          status: 'done',
          name: 'img',
        }];
        temp.site_info.wxapp_cover_url=undefined;
        temp.site_info.wxapp_cover_two_url=undefined;
        temp.site_info.wxapp_covers_url=undefined;

        temp.site_info.survey_img_url=undefined;
        temp.site_info.task_one_img_url=undefined;
        temp.site_info.task_two_img_url=undefined;
        temp.site_info.task_three_img_url=undefined;
        temp.site_info.wxapp_api_cover_url=undefined;

        this.$refs.webRef.$refs.basicForm.form.setFieldsValue(temp.site_info);
        this.$refs.aliRef.$refs.basicForm.form.setFieldsValue(temp.aliyun_settings);
        this.$refs.commentRef.$refs.basicForm.form.setFieldsValue(temp.brush_settings);
        this.$refs.miniRef.$refs.basicForm.form.setFieldsValue(temp.wxapp_settings);
        this.privacyContent=temp.privacy_settings.privacy_content;
		this.antiContent=temp.anti_bribery.anti_bribery_content;
		this.promoteContent=temp.promote_industry_rule.promote_industry_rule_content;
        this.doctorContent=temp.agreement_settings.agreement_content;
        this.aboutContent=temp.daren_settings.daren_content;
      }
    },
    handleChange(){

    },
    // 网站信息提交
    async handleSubmit(){
      // 网站信息
      let options={};
      this.$refs.webRef.$refs.basicForm.form.validateFields((err, values) => {
        if (!err) {
          values.wxapp_cover=values.wxapp_cover.length>0?values.wxapp_cover[0].uid:undefined;
          values.wxapp_cover_two=values.wxapp_cover_two.length>0?values.wxapp_cover_two[0].uid:undefined;
          values.wxapp_covers=values.wxapp_covers.length>0?values.wxapp_covers[0].uid:undefined;
          values.survey_img=values.survey_img.length>0?values.survey_img[0].uid:undefined;
          values.task_one_img=values.task_one_img.length>0?values.task_one_img[0].uid:undefined;
          values.task_two_img=values.task_two_img.length>0?values.task_two_img[0].uid:undefined;
          values.task_three_img=values.task_three_img.length>0?values.task_three_img[0].uid:undefined;
          values.wxapp_api_cover=values.wxapp_api_cover.length>0?values.wxapp_api_cover[0].uid:undefined;
          options=values;
        }
      });
      // 隐私
	    let privacy_settings={privacy_content: this.privacyContent};
	  // 反商业贿赂协议
	 let anti_bribery={anti_bribery_content: this.antiContent};
	 // 推广服务商推广行为准则
	 let promote_industry_rule={promote_industry_rule_content: this.promoteContent};
      // 服务端协议
      let agreement_settings={agreement_content: this.doctorContent};
      // 关于我们
      let daren_settings={daren_content: this.aboutContent};
      // 阿里云
      let aliyun_settings={};
      this.$refs.aliRef.$refs.basicForm.form.validateFields((err, values) => {
        if (!err) {
          aliyun_settings=values;
        }
      });
      // 评论
      let brush_settings={};
      this.$refs.commentRef.$refs.basicForm.form.validateFields((err, values) => {
        if (!err) {
          brush_settings=values;
        }
      });
      // 小程序
      let wxapp_settings={};
      this.$refs.miniRef.$refs.basicForm.form.validateFields((err, values) => {
        if (!err) {
          wxapp_settings=values;
        }
      });
      this.btnIsLoading=true;
      let result =await this.$http.post('/option/saveOption', {
        options,
        privacy_settings,
		anti_bribery,
		promote_industry_rule,
        agreement_settings,
        daren_settings,
        aliyun_settings,
        brush_settings,
        wxapp_settings,
      });
      this.btnIsLoading=false;
      if(result.data.status===1){
        this.$message.success('操作成功！');
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-container{
  text-align: right;
  margin-top:20px;
}
</style>